import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const routes: RouteRecordRaw[] = [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/Login.vue'),
        meta: { public: true },
    },
    {
        path: '/',
        component: () => import('@/layouts/AdminLayout.vue'),
        children: [
            { path: '', name: 'dashboard', component: () => import('@/views/Dashboard.vue') },
            { path: 'tenants', name: 'tenants.index', component: () => import('@/views/tenants/Index.vue') },
            { path: 'plans', name: 'plans.index', component: () => import('@/views/Plans.vue') },
            { path: 'billing', name: 'billing', component: () => import('@/views/Billing.vue') },
            { path: 'announcements', name: 'announcements', component: () => import('@/views/Announcements.vue') },
            { path: 'integrations', name: 'integrations', component: () => import('@/views/Integrations.vue') },
            { path: 'settings', name: 'settings', component: () => import('@/views/Settings.vue') },
            { path: 'email-templates', name: 'email-templates', component: () => import('@/views/EmailTemplates.vue') },
            { path: 'audit-log', name: 'audit-log', component: () => import('@/views/AuditLog.vue') },
            { path: 'admins', name: 'admins', component: () => import('@/views/Admins.vue') },
            { path: 'tenants/new', name: 'tenants.create', component: () => import('@/views/tenants/Create.vue') },
            { path: 'tenants/:id/modules', name: 'tenants.modules', component: () => import('@/views/tenants/Modules.vue') },
            // Read-only data browser, reached from the tenant row. Not in the
            // sidebar: it only means anything for a specific tenant.
            { path: 'tenants/:id/data', name: 'tenants.data', component: () => import('@/views/tenants/Data.vue') },
        ],
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: () => import('@/views/NotFound.vue'),
        meta: { public: true },
    },
];

export const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach(async (to) => {
    if (to.meta.public) return true;

    const auth = useAuthStore();
    if (!auth.user) {
        try {
            await auth.fetchUser();
        } catch {
            return { name: 'login', query: { redirect: to.fullPath } };
        }
    }
    return true;
});
